import StyleQuestionDetail from "../../../../partial/styles/StyleQuestionDetail";
import React from "react";
import {ListItemIcon, TextField} from "@material-ui/core";
import CustomCheckbox from "../../../../partial/CustomCheckbox";
import RadioButtonUnchecked from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonChecked from "@material-ui/icons/RadioButtonChecked";
import {questionTypes} from "../../../../../config/constants";
import AnswerListItem from "../../../test/AnswerListItem";
import CheckBoxIconBlank from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";


const OtherAnswerDetail = (props) => {
    const {answer, index, questionType} = props;
    const classes = StyleQuestionDetail();

    const unCheckIcon = (questionType === questionTypes.MULTIPLE_CHOICE) ?
        <RadioButtonUnchecked className={classes.checkBox}/> : <CheckBoxIconBlank className={classes.checkBox}/>;
    const checkedIcon = (questionType === questionTypes.MULTIPLE_CHOICE) ?
        <RadioButtonChecked className={classes.checkBox}/> : <CheckBoxIcon className={classes.checkBox}/>;

    return (
        <React.Fragment>
            <AnswerListItem
                disableRipple
                button
                key={index}
                selected={answer.isStudentAnswer}
                style={{height: 'auto'}}
            >
                <ListItemIcon style={{minWidth: 10}}>
                    <CustomCheckbox
                        icon={unCheckIcon}
                        checkedIcon={checkedIcon}
                        edge="start"
                        checked={answer.isStudentAnswer && answer.text !== ""}
                        tabIndex={-1}
                        disableRipple
                        value={answer.text}
                        disabled={true}
                    />

                </ListItemIcon>
                <TextField
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={answer.text}
                    disabled
                >
                </TextField>
            </AnswerListItem>

        </React.Fragment>
    );
};
export default OtherAnswerDetail;